import { useState } from "react";

import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { TimeZoneSettings } from "./TimeZoneSettingsV2/TimeZoneSettings";
import { ParentLayout } from "../AssistantTools/components/ParentLayout";
import { SectionLayout } from "../AssistantTools/components/SectionLayout";
import { SectionItem } from "../AssistantTools/components/SectionItem";
import { MainLayout } from "../AssistantTools/components/MainLayout";
import ChatWelcomeMessages from "../MessagingSettings/ChatWelcomeMessagesV2";
import MessageDelay from "../MessagingSettings/MessageDelayV2";
import FilteringSettings from "../MessagingSettings/FilteringSettings";
import ConversationReminder from "../MessagingSettings/ConversationReminder";
import PastContextSettings from "../PastContextSettings";

enum SETTINGS {
  WELCOME_MESSAGES = "Welcome Message",
  DELAY = "Delay Settings",
  OFFICE_HOURS = "Office hours",
  FILTERING_SETTINGS = "Response Filters",
  CONVERSATION_REMINDERS = "Conversation Reminders",
  PAST_CONTEXT = "Conversation History"
}

const SettingsComponent = {
  [SETTINGS.WELCOME_MESSAGES]: (props) => <ChatWelcomeMessages {...props} />,
  [SETTINGS.OFFICE_HOURS]: (props) => <TimeZoneSettings {...props} />,
  [SETTINGS.DELAY]: (props) => <MessageDelay {...props} />,
  [SETTINGS.FILTERING_SETTINGS]: (props) => <FilteringSettings {...props} />,
  [SETTINGS.CONVERSATION_REMINDERS]: (props) => (
    <ConversationReminder {...props} />
  ),
  [SETTINGS.PAST_CONTEXT]: (props) => <PastContextSettings {...props} />
};

function MessengerAssistantSettings(props) {
  const [activeSetting, setActiveSetting] = useState(SETTINGS.WELCOME_MESSAGES);

  const settings = Object.values(SETTINGS).reduce((acc, setting) => {
    return [
      ...acc,
      { name: setting, href: "#", current: setting === activeSetting },
    ];
  }, []);

  return (
    <ParentLayout>
      <SectionLayout>
        {settings.map((setting) => (
          <SectionItem
            sectionName={setting.name}
            isActive={setting.current}
            onSectionClick={() => setActiveSetting(setting.name)}
          />
        ))}
      </SectionLayout>
      <MainLayout>
        {SettingsComponent[activeSetting]({
          ...props,
        })}
      </MainLayout>
    </ParentLayout>
  );
}

export { MessengerAssistantSettings };
